import Image, { StaticImageData } from 'next/image';
import React from 'react';

import Card from './Card';
import ContinuesCardSlider from '../../ProjectPage/CardSlider/ContinuesCardSlider';
import {
  Anand_Garg,
  Aseem,
  Ashwinder_Sujata_Gaur,
  Asif_Masani,
  Bhuvana,
  Deb_gooha,
  Harjeet_Sujata_Gaur,
  LineLarge,
  Rachit_Sujata_Gaur,
  Rahul_Sujata_Gaur,
  Rajesh_Sujata_Gaur,
  Vineet_Agarwal,
  Vinit_Rai,
  Vivek_Chadha,
} from '../../../../assets';

interface CardScrollSectionProps {
  isAbout?: boolean;
}

const CardScrollSection: React.FC<CardScrollSectionProps> = () => {
  const numCards = 200;
  const cardWidth = 220;
  const cardData = [
    {
      image: Aseem,
      name: 'Aseem Singhal, Founder & CEO , Unfluke',
    },
    {
      image: Ashwinder_Sujata_Gaur,
      name: 'Ashwinder R Singh, CEO, Residential at Bhartiya Urban',
    },
    {
      image: Rachit_Sujata_Gaur,
      name: 'Rachit Chawla, Founder & CEO , Finway FSC & Multifly',
    },
    {
      image: Rahul_Sujata_Gaur,
      name: 'Rahul Saria, Co-Founder, Fincurious',
    },
    {
      image: Harjeet_Sujata_Gaur,
      name: 'Harjeet Khanduja, Senior VP - HR, Reliance Jio',
    },
    {
      image: Rajesh_Sujata_Gaur,
      name: 'Rajesh Srinivasan, Founder , Mindful Marketing',
    },
    {
      image: Anand_Garg,
      name: 'Cluster Business Head - OTX & Trade Generics',
    },
    {
      image: Asif_Masani,
      name: 'Chief Learning Officer at FP&A Professionals',
    },
    {
      image: Bhuvana,
      name: 'CMO at Spinning Wheel',
    },
    {
      image: Deb_gooha,
      name: 'Chief Growth Office at MPay',
    },

    {
      image: Vineet_Agarwal,
      name: 'Early-Stage Investor',
    },
    {
      image: Vinit_Rai,
      name: 'Managing Director at JM Financial Private Equity',
    },
    {
      image: Vivek_Chadha,
      name: 'TiE Charter Member',
    },
  ];

  return (
    <>
      <div>
        <div className='lg:pb-16'>
          {/* <div className=' flex flex-col gap-y-6 justify-center'>
            <span className='text-2xl mt-12 md:mt-0 sm:text-4xl xl:text-[36px] text-fadedWhite flex flex-wrap text-center justify-center'>
              Meet India’s ‘<p className='text-primary'>Business Leaders</p>’
            </span>
            <span className='flex justify-center text-xl px-4 sm:text-3xl font-medium text-textGray'>
              <p className='lg:w-1/2 text-center'>
                Packed with Knowledge, Insights and Insider Tools for you,
                directly from Industry Leaders!
              </p>
            </span>
          </div> */}
          <div className='flex flex-col text-center gap-y-2'>
            <span className='font-bold flex justify-center text-2xl xl:text-[36px]'>
              <div className='flex flex-col text-center sm:whitespace-nowrap xl:leading-10 text-fadedWhite'>
                <span className='font-bold md:w-min '>
                  <span className='flex'>
                    Meet India’s ‘
                    <p className='text-primary'>Business Leaders</p>’
                  </span>

                  <div className='w-fit hidden md:flex '>
                    <Image
                      src={LineLarge}
                      alt='LineLarge'
                      className='object-contain w-full h-full'
                    />
                  </div>
                </span>
              </div>
            </span>
            <span className='text-center xl:text-[20px] flex justify-center text-textGray'>
              <p className='md:w-2/5 text-fadedWhite'>
                Packed with Knowledge, Insights and Insider Tools for you,
                directly from Industry Leaders!
              </p>
            </span>
          </div>
          <div className='pt-10 flex flex-col gap-y-4 overflow-hidden'>
            <span>
              {' '}
              <ContinuesCardSlider
                cardWidth={cardWidth}
                numCards={numCards}
                reverse={false}
              >
                {Array.from({ length: 200 }).map((_, index) => (
                  <div
                    key={index}
                    className='w-full flex bg-bgColor'
                    style={{ width: `${cardWidth}px` }}
                  >
                    <Card
                      key={index}
                      image={
                        cardData[index % cardData.length]
                          ?.image as StaticImageData
                      }
                      name={cardData[index % cardData.length]?.name as string}
                    />
                  </div>
                ))}
              </ContinuesCardSlider>
            </span>
            <span>
              {' '}
              <ContinuesCardSlider
                cardWidth={cardWidth}
                numCards={numCards}
                reverse={true}
              >
                {Array.from({ length: 200 }).map((_, index) => (
                  <div
                    key={index}
                    className='w-full flex bg-bgColor'
                    style={{ width: `${cardWidth}px` }}
                  >
                    <Card
                      key={index}
                      image={
                        cardData[index % cardData.length]
                          ?.image as StaticImageData
                      }
                      name={cardData[index % cardData.length]?.name as string}
                    />
                  </div>
                ))}
              </ContinuesCardSlider>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default CardScrollSection;
